import { responsiveVariables } from "../../../utilities/props.js";
import "./padding.css";
const padding = (value) => {
    if (!value)
        return {};
    return { variables: responsiveVariables("--rs-p", value) };
};
export const paddingTop = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-p-top", value) };
};
export const paddingBottom = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-p-bottom", value) };
};
export const paddingStart = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-p-start", value) };
};
export const paddingEnd = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-p-end", value) };
};
export const paddingInline = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-p-inline", value) };
};
export const paddingBlock = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-p-block", value) };
};
export default padding;
